import { StringDevViewportLayer } from "./StringDevViewportLayer";

interface SharedViewportLayerEntry {
  layer: StringDevViewportLayer;
  refs: number;
  zIndex: number;
}

export class StringDevOverlayRegistry {
  private static instance: StringDevOverlayRegistry | null = null;
  private readonly layers = new Map<string, SharedViewportLayerEntry>();

  public static getInstance(): StringDevOverlayRegistry {
    if (!this.instance) {
      this.instance = new StringDevOverlayRegistry();
    }
    return this.instance;
  }

  public acquire(id: string, zIndex: number): StringDevViewportLayer {
    const existing = this.layers.get(id);
    if (existing) {
      if (existing.zIndex !== zIndex) {
        throw new Error(
          `Shared devtools layer "${id}" already exists with z-index ${existing.zIndex}, requested ${zIndex}.`,
        );
      }
      existing.refs += 1;
      return existing.layer;
    }

    const layer = new StringDevViewportLayer(id, zIndex);
    this.layers.set(id, { layer, refs: 1, zIndex });
    return layer;
  }

  public release(id: string): void {
    const existing = this.layers.get(id);
    if (!existing) {
      return;
    }

    existing.refs -= 1;
    if (existing.refs > 0) {
      return;
    }

    existing.layer.destroy();
    this.layers.delete(id);
  }
}
